import angular from 'angular';

import MechanicSearchResultsHtml from '../mechanics/templates/mechanic.search.results.html';

export function EventTimesCtrl (
  $rootScope,
  $scope,
  $timeout,
  $translate,
  $uibModalInstance,
  eventItem,
  eventTimeApi,
  eventTimeId,
  eventTimes,
  messages,
  streamSearch
) {

  $scope.mechanicSearchResultsTemplateUrl = MechanicSearchResultsHtml;

  $scope.eventTimeApi = eventTimeApi;

  $scope.eventItem     = eventItem;
  $scope.eventTimes    = eventTimes;
  $scope.flipped       = false;
  $scope.initializing  = true;
  $scope.searchDays    = [];
  $scope.searching     = false;
  $scope.selectedItems = [];

  $scope.eventTime = {
    estimated_hours: parseFloat($scope.eventItem.quantity),
    event_id       : $scope.eventItem.event_id,
    event_item_id  : $scope.eventItem.id
  };

  $scope.tableSettings = {
    broadcast: 'filterEventTimes',
    columns  : [
      {
        classes: 'text-left',
        field  : 'display_name',
        header : {
          classes: 'text-left',
          text   : $translate.instant('GENERAL_SPACE.FIELD.NAME')
        }
      },
      {
        classes: 'text-left',
        field  : 'event_date',
        header : {
          classes: 'text-left',
          text   : $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-left',
        field  : 'local_start_time',
        header : {
          classes: 'text-left',
          text   : $translate.instant('JS_SPACE.COLUMNS.TIME')
        },
        pipe    : 'globalDate',
        pipeArgs: ['h:mm a']
      },
      {
        classes: 'text-left',
        field  : 'estimated_hours',
        header : {
          classes: 'text-left',
          text   : $translate.instant('VEHICLE_SPACE.HOURS')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_EVENT_TIMES')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.searchTableSettings = {
    broadcast: 'filterEventTimesSearch',
    columns  : [
      {
        classes: 'text-left',
        field  : 'mechanic',
        header : {
          classes: 'text-left',
          text   : $translate.instant('GENERAL_SPACE.FIELD.NAME')
        },
      },
      {
        classes: 'text-left',
        field  : 'date',
        header : {
          classes: 'text-left',
          text   : $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'date'
      },
      {
        classes: 'text-left',
        field  : 'timestamp',
        header : {
          classes: 'text-left',
          text   : $translate.instant('JS_SPACE.COLUMNS.TIME')
        },
        pipe    : 'globalDate',
        pipeArgs: ['h:mm a']
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_EVENT_TIMES')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.mechanicSearch = {
    list: [],
    search (typed) {
      var _this = this;

      return streamSearch.search('mechanics', typed)
      .then(mechanics => _this.list.concat(mechanics));
    },
    format: mechanic => angular.isObject(mechanic) ? mechanic.display_name: mechanic,
    choose: (mechanic) => {
      $scope.eventTime.mechanic_id = mechanic.id;
    }
  };

  $scope.clear = function (row) {
    $scope.clearing = true;

    $scope.eventTimeApi.clearMechanic({
      estimated_hours : row.entity.estimated_hours,
      event_date      : row.entity.event_date,
      event_id        : row.entity.event_id,
      event_item_id   : row.entity.event_item_id,
      id              : row.entity.id,
      local_start_time: row.entity.local_start_time,
      mechanic_id     : null
    })
    .then(() => {
      $uibModalInstance.close($translate.instant('JS_SPACE.MESSAGES.EMPLOYEE_CLEARED', {
        title: $rootScope.Company.labels.employeeTitle
      }));
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.delete = function () {
    $scope.eventTimeApi.delete($scope.selectedItems[0].id)
    .then(() => {
      $uibModalInstance.close($translate.instant('JS_SPACE.MESSAGES.DELETED.EVENT_TIME') );
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.flipToCreate = function () {
    $scope.COL_FIELD = {};
    $scope.flipped   = true;
    $scope.searching = false;

    $scope.eventTimeApi.refresh($scope.eventItem, $scope.eventTime);

    $scope.$emit('flipModal');
  };

  $scope.flipToSearch = function () {
    $scope.flipped   = true;
    $scope.searching = true;

    $scope.$emit('flipModal');
  };

  $scope.flipToSearchResults = function () {
    $scope.flipped = false;

    $scope.$emit('flipModal');
  };

  $scope.flipToUpdate = function () {
    $scope.COL_FIELD = $scope.selectedItems[0];
    $scope.flipped   = true;
    $scope.searching = false;

    $scope.eventTimeApi.configureUpdate($scope.selectedItems[0], $scope.eventTime);

    $scope.$emit('flipModal');
  };

  $scope.flipToFront = function () {
    $scope.eventTimes = eventTimes;
    $scope.flipped    = false;
    $scope.searching  = false;

    $scope.eventTimes.map(eventTime => {
      eventTime.selected = false;

      return eventTime;
    });

    $scope.selectedItems = [];

    $scope.eventTimeApi.refresh($scope.eventItem, $scope.eventTime);

    $scope.$emit('flipModal');
  };

  $scope.init = function () {
    const delay = 1000;

    /**
     * if no existing event times, flip
     * the modal to the create side.
     */
    if (!$scope.eventTimes.length) {
      return $timeout(() => $scope.flipToCreate(), delay);
    }

    /**
     * if only one event time, select it
     * and flip modal to update side.
     */
    else if ($scope.eventTimes.length === 1 && !$scope.eventTimes[0].mechanic_id) {
      return $timeout(() => {
        $scope.eventTimes[0].selected = true;

        $scope.selectedItems.push($scope.eventTimes[0]);

        $scope.flipToUpdate();
      }, delay);
    }

    /**
     * if eventTimeId, user came from a
     * different page to view a specific
     * event time. Find it, select it,
     * and flip to update side.
     */
    else if (eventTimeId) {
      for ( let i = 0; i < $scope.eventTimes.length; i++ ) {
        if ($scope.eventTimes[i].id === eventTimeId) {
          $scope.selectedItems.push($scope.eventTimes[i]);

          i = $scope.eventTimes.length;
        }
      }

      if ($scope.selectedItems.length) {
        return $timeout(() => $scope.flipToUpdate(), delay);
      }
    }

    return $timeout(() => angular.noop(), delay);
  };

  $scope.selectEventTime = function ( eventTime ) {
    if ( eventTime.selected ) {
      $scope.selectedItems[0] = eventTime;
    }
    else {
      $scope.selectedItems = [];
    }
  };

  $scope.save = function () {
    $scope.eventTimeApi.save($scope.COL_FIELD, $scope.eventTime)
    .then(() => {
      $uibModalInstance.close($translate.instant('JS_SPACE.MESSAGES.SAVED.EVENT_TIME') );
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.saveSearched = function () {
    $scope.eventTimeApi.saveSearched($scope.selectedItems[0], $scope.eventTime)
    .then(() => {
      $uibModalInstance.close($translate.instant('JS_SPACE.MESSAGES.SAVED.EVENT_TIME'));
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.search = function () {
    $scope.eventTimeApi.search($scope.after_time, $scope.before_time, $scope.searchDays, $scope.eventTime)
    .then(eventTimes => {
      $scope.eventTimes = eventTimes;

      $scope.flipToSearchResults();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.selectTime = function(event, property) {
    const picker =angular.element(event.currentTarget).datetimepicker({
      initialDate : new Date(),
      showMeridian: true,
      startView   : 'day'
    })
    .on('changeDate', ev => {
      const date = new Date(ev.date.valueOf());

      $scope.eventTime[property] = $scope[property] = moment(new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes()
      ).toISOString());

      if (!$scope.$$phase) {
        $scope.$apply();
      }

      picker.datetimepicker('hide');
    }).datetimepicker('show');
  };

  $scope.toggleSearchDay = function (day) {
    if ($scope.searchDays.indexOf(day) < 0) {
      $scope.searchDays.push(day);
    }
    else {
      $scope.searchDays.splice($scope.searchDays.indexOf(day), 1);
    }
  };

  $scope.init()
  .then(() => {
    $scope.initializing = false;
  });
}